export default __webpack_public_path__ + "static/media/WarningRed.4191ec0b.svg";